import { createBrowserRouter, RouterProvider, } from "react-router-dom";
import MainContainer from "./components/layout/MainContainer";
import { routes } from "./utils/constants";
import { ModalProvider } from "context/ModalContext";
import GlobalModals from "components/GlobalModals";

let router = createBrowserRouter(routes);

export default function App() {
  return (
      <ModalProvider>
        <MainContainer>
          <RouterProvider
            router={router}
            fallbackElement={<p>Loading...</p>}
          />
        </MainContainer>
        <GlobalModals />
      </ModalProvider>
  );
}